import { Component, OnInit, Input } from '@angular/core';
import { Course } from 'lms-api';
import { LMSContentService } from 'lms-api';
import { Observable } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-evaluation',
  templateUrl: './course-evaluation.component.html',
  styleUrls: ['./course-evaluation.component.scss']
})
export class CourseEvaluationComponent implements OnInit {
  @Input() course: Course;
  evalQuestions$: Observable<string[]>;
  private questions: string[];
  options: string[];
  public evalForm: UntypedFormGroup;

  constructor(private lmsContentService: LMSContentService, private ucdService: UserCourseDataService) {
    this.options = ['--Please Select--', '1 - Strongly Agree', '2', '3', '4 - Agree', '5', '6', '7 - Strongly Disagree'];
    this.evalForm = new UntypedFormGroup({});
  }

  ngOnInit() {
    this.evalQuestions$ = this.lmsContentService.GetContent("Evaluation Questions");
    this.evalQuestions$.subscribe(questions => {
      this.questions = questions;
        for (let i = 1; i <= Object.keys(questions).length; i++) {
          this.evalForm.addControl('eval_' + i, new UntypedFormControl('', Validators.required));
        }
      this.evalForm.addControl('eval_comments', new UntypedFormControl());
    });
  }

  submitEval(evalForm: UntypedFormGroup) {
    let answers = {};
    for(let formId in evalForm.value) {
      let qId = parseInt(formId.split('_')[1]);
      let question = isNaN(qId) ? 'Comments' : this.questions[qId - 1];
      answers[question] = evalForm.value[formId];
    }
    this.ucdService.SubmitEvaluation(this.course.netforum_course_id, answers);
  }
}
